/* =============================================
   BULLETMOLE RENTALS — THEME JS
============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // --- MOBILE NAV TOGGLE ---
  const navToggle = document.querySelector('.nav-toggle');
  const navMenu = document.querySelector('.nav-menu');

  if (navToggle && navMenu) {
    navToggle.addEventListener('click', function () {
      const isOpen = navMenu.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('nav-open', isOpen);
    });
  }

  document.querySelectorAll('.nav-menu a').forEach(function (link) {
    link.addEventListener('click', function () {
      if (navMenu) navMenu.classList.remove('is-open');
      if (navToggle) navToggle.setAttribute('aria-expanded', false);
      document.body.classList.remove('nav-open');
    });
  });

  // --- STICKY HEADER SHADOW ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // --- COLLECTION FILTER & SORT ---
  const filterBtns = document.querySelectorAll('.filter-btn');
  const sortSelect = document.querySelector('.sort-select');
  const productGrid = document.querySelector('.product-grid');

  if (filterBtns.length && productGrid) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Update active state
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        const filter = btn.dataset.filter;
        const cards = productGrid.querySelectorAll('.product-card');

        cards.forEach(function (card) {
          if (filter === 'all' || card.dataset.type === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  if (sortSelect && productGrid) {
    sortSelect.addEventListener('change', function () {
      const cards = Array.from(productGrid.querySelectorAll('.product-card'));
      const val = sortSelect.value;

      cards.sort(function (a, b) {
        const priceA = parseFloat(a.dataset.price || 0);
        const priceB = parseFloat(b.dataset.price || 0);
        const titleA = (a.dataset.title || '').toLowerCase();
        const titleB = (b.dataset.title || '').toLowerCase();

        if (val === 'price-asc') return priceA - priceB;
        if (val === 'price-desc') return priceB - priceA;
        if (val === 'title-asc') return titleA.localeCompare(titleB);
        if (val === 'title-desc') return titleB.localeCompare(titleA);
        return 0;
      });

      cards.forEach(function (card) { productGrid.appendChild(card); });
    });
  }

  // --- MOBILE FILTER DRAWER TOGGLE ---
  const filterToggle = document.querySelector('.filter-drawer-toggle');
  const filterDrawer = document.querySelector('.filter-drawer');

  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener('click', function () {
      const isOpen = filterDrawer.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen);
    });
  }

});
